import { Injectable, inject } from '@angular/core';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';

@Injectable({
  providedIn: 'root',
})
export class NativeSettingsService {
  openNativeSettings = inject(OpenNativeSettings);

  constructor() {}

  openAndroidSecurityPage(): Promise<any> {
    return this.openNativeSettings.open('security');
  }

  openiOSSettingsPage(): Promise<any> {
    return this.openNativeSettings.open('settings');
  }
}
